import { borderRadius, Icon, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { DraggableWatchlistRow } from '../draggable-watchlist-row/DraggableWatchlistRow';

export const Container = styled.div<{ $inModal: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: ${props => props.$inModal && 'calc(100% - 60px)'};
  z-index: ${props => !props.$inModal && '1'};
  background: var(--background-soft);

  ${props =>
    !props.$inModal &&
    css`
      width: 100%;
      max-width: 914px;
      max-height: 724px;
      border: 1px solid var(--border-soft);
      padding: 20px 20px 0px;
      ${borderRadius.r2};
    `}
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 12px;
  overflow: hidden;
  height: 100%;

  ${DraggableWatchlistRow.Styled.CellContentWrapper} {
    width: 20px;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;
  margin-top: auto;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: end;
  flex: 1;
  gap: 10px;
  width: 100%;
`;

export const ErrorMessage = styled.p`
  color: var(--text-critical);
  ${typographyV2.titleBase}
`;

export const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;
